import { useState } from "react";

const features = [
  {
    svgIcon: (
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="20" width="45" height="55" rx="4" fill="#FFF9C4" stroke="#F9A825" strokeWidth="1.5"/>
        <rect x="18" y="8" width="45" height="55" rx="4" fill="#FFFDE7" stroke="#F9A825" strokeWidth="1.5"/>
        <rect x="26" y="14" width="12" height="16" rx="2" fill="#29B6F6" stroke="#0288D1" strokeWidth="1"/>
        <rect x="26" y="14" width="12" height="5" rx="1" fill="#0288D1"/>
        <text x="40" y="42" fontSize="8" fill="#1565C0" fontWeight="bold" textAnchor="middle">BOOK</text>
        <rect x="28" y="46" width="20" height="2" rx="1" fill="#F9A825"/>
        <rect x="28" y="51" width="14" height="2" rx="1" fill="#F9A825"/>
      </svg>
    ),
    title: "Quick Booking",
    desc: "We provide quick and convenient flight bookings with amazing discounts.",
  },
  {
    svgIcon: (
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="40" cy="72" rx="20" ry="4" fill="#e0e0e0" opacity="0.5"/>
        <path d="M30 18 C28 10 50 8 52 18 L56 55 C56 60 24 60 24 55 Z" fill="#F06292" stroke="#E91E63" strokeWidth="1"/>
        <path d="M35 18 C33 10 55 8 57 18 L61 55 C61 60 29 60 29 55 Z" fill="#EF5350" stroke="#C62828" strokeWidth="1"/>
        <circle cx="34" cy="30" r="8" fill="#FFC107" stroke="#FF8F00" strokeWidth="1.5"/>
        <circle cx="34" cy="30" r="4" fill="#FF6F00"/>
        <text x="34" y="34" fontSize="6" fill="white" fontWeight="bold" textAnchor="middle">%</text>
        <path d="M30 16 Q32 12 34 10" stroke="#795548" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M35 16 Q37 11 39 9" stroke="#795548" strokeWidth="2" strokeLinecap="round" fill="none"/>
      </svg>
    ),
    title: "Lowest Price",
    desc: "We ensure lowest pricing on hotel reservations and airline tickets.",
  },
  {
    svgIcon: (
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="38" r="26" fill="#FFF3E0" stroke="#FF9800" strokeWidth="1.5"/>
        <path d="M40 14 C40 14 28 26 28 36 C28 42.6 33.4 48 40 48 C46.6 48 52 42.6 52 36 C52 26 40 14 40 14Z" fill="#FF5722" opacity="0.85"/>
        <circle cx="40" cy="38" r="10" fill="#FF9800" stroke="#E65100" strokeWidth="1.5"/>
        <path d="M36 38 L39 41 L45 33" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
    title: "Exciting Offers",
    desc: "Enjoy exciting offers on flights, hotels and buses booking.",
  },
  {
    svgIcon: (
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="36" cy="30" r="18" fill="#E3F2FD" stroke="#90CAF9" strokeWidth="1.5"/>
        <circle cx="36" cy="24" r="7" fill="#BBDEFB" stroke="#64B5F6" strokeWidth="1"/>
        <path d="M22 44 C22 37 50 37 50 44 L50 50 C50 54 22 54 22 50 Z" fill="#90CAF9" stroke="#64B5F6" strokeWidth="1"/>
        <circle cx="56" cy="22" r="10" fill="#A5D6A7" stroke="#66BB6A" strokeWidth="1.5"/>
        <text x="56" y="27" fontSize="14" textAnchor="middle">💬</text>
      </svg>
    ),
    title: "24/7 Support",
    desc: "Get 24/7 support for booking related queries. We're here to help.",
  },
];

const appFeatures = [
  "Get exclusive offers & prices",
  "Manage trip and Ticket Booking",
  "Activity suggestion based on destination",
  "All trip bookings in a single platform",
];

function WhyBookWithUs() {
  const [hovered, setHovered] = useState(null);

  return (
    <section style={{ padding: "3rem 1.5rem", background: "#eef2f7" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h2 style={{
          textAlign: "center",
          fontSize: 26,
          fontWeight: 700,
          color: "#0a2a6e",
          marginBottom: "2rem",
        }}>
          Why Booking with Us
        </h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 20,
        }}>
          {features.map((item, i) => (
            <div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: "#ffffff",
                borderRadius: 16,
                border: hovered === i ? "1.5px solid #b0c4de" : "1px solid #e2e8f0",
                padding: "2rem 1.5rem",
                textAlign: "center",
                cursor: "default",
                boxShadow: hovered === i
                  ? "0 6px 24px rgba(24,95,165,0.10)"
                  : "0 1px 6px rgba(0,0,0,0.05)",
                transition: "box-shadow 0.2s ease, border 0.2s ease, transform 0.2s ease",
                transform: hovered === i ? "translateY(-4px)" : "translateY(0)",
              }}
            >
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "1rem",
                height: 90,
              }}>
                {item.svgIcon}
              </div>
              <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1a202c", marginBottom: 10 }}>
                {item.title}
              </h3>
              <p style={{ fontSize: 13, color: "#718096", lineHeight: 1.6, margin: 0 }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// function MobileAppSection() {
//   return (
//     <section style={{ background: "#ffffff", padding: "3rem 1.5rem", borderTop: "1px solid #e2e8f0" }}>
//       <div style={{ maxWidth: 1100, margin: "0 auto" }}>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 32, alignItems: "center" }}>

//           {/* Left Content */}
//           <div style={{ flex: "1 1 300px", paddingRight: "1rem" }}>
//             <h2 style={{
//               fontSize: 22,
//               fontWeight: 700,
//               color: "#0a2a6e",
//               marginBottom: "1rem",
//               lineHeight: 1.4,
//             }}>
//               Get more out of Bookbyown.ae with our mobile app
//             </h2>

//             <p style={{ fontSize: 14, color: "#4a5568", lineHeight: 1.7, marginBottom: "1.25rem" }}>
//               Download the Bookbyown.ae mobile app for one-touch access to your next travel
//               adventure. With the Bookbyown mobile app you'll get access to hidden features and
//               special offers.
//             </p>

//             <ul style={{
//               listStyle: "none",
//               padding: 0,
//               margin: "0 0 1.75rem 0",
//               display: "flex",
//               flexDirection: "column",
//               gap: 10,
//             }}>
//               {appFeatures.map((f, i) => (
//                 <li key={i} style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   fontSize: 14,
//                   color: "#2d3748",
//                   fontWeight: 500,
//                 }}>
//                   <span style={{
//                     width: 22,
//                     height: 22,
//                     borderRadius: "50%",
//                     background: "#0a2a6e",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}>
//                     <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//                       <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                   </span>
//                   {f}
//                 </li>
//               ))}
//             </ul>

//             {/* App Buttons */}
//             <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
//               {/* Google Play */}
//               <a href="#" style={{
//                 display: "flex", alignItems: "center", gap: 10,
//                 padding: "10px 20px", background: "#0a2a6e", color: "#fff",
//                 borderRadius: 10, border: "1.5px solid #1e3a8a",
//                 opacity: 0.45, pointerEvents: "none", userSelect: "none",
//                 textDecoration: "none", minWidth: 150,
//               }}>
//                 <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
//                   <path d="M3.18 23.76c.3.17.64.24.98.2L14.72 12 3.18.04A1.5 1.5 0 003 .76v22.5c0 .19.06.36.18.5zM17.9 8.9l-2.56-1.47L12.48 12l2.86 2.57 2.56-1.47A1.75 1.75 0 0018.75 12c0-.67-.34-1.27-.85-1.1zM4.5 1.3l11.1 6.37-2.88 2.6L4.5 1.3zM4.5 22.7l8.22-8.97 2.88 2.6L4.5 22.7z"/>
//                 </svg>
//                 <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
//                   <span style={{ fontSize: 10, opacity: 0.8 }}>GET IT ON</span>
//                   <span style={{ fontSize: 15, fontWeight: 600 }}>Google Play</span>
//                 </span>
//               </a>

//               {/* App Store */}
//               <a href="#" style={{
//                 display: "flex", alignItems: "center", gap: 10,
//                 padding: "10px 20px", background: "#0a2a6e", color: "#fff",
//                 borderRadius: 10, border: "1.5px solid #1e3a8a",
//                 opacity: 0.45, pointerEvents: "none", userSelect: "none",
//                 textDecoration: "none", minWidth: 150,
//               }}>
//                 <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
//                   <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
//                 </svg>
//                 <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
//                   <span style={{ fontSize: 10, opacity: 0.8 }}>Download on the</span>
//                   <span style={{ fontSize: 15, fontWeight: 600 }}>App Store</span>
//                 </span>
//               </a>
//             </div>
//           </div>

//           {/* Right — QR Code */}
//       {/* Right — QR Code */}
// <div style={{ flex: "0 0 auto", display: "flex", justifyContent: "center" }}>
//   <div style={{
//     background: "#fff",
//     borderRadius: 16,
//     border: "1px solid #e2e8f0",
//     padding: "2rem 2.5rem",
//     textAlign: "center",
//     boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
//     minWidth: 180,
//   }}>
//     <div style={{ margin: "0 auto 12px" }}>
//       <img
//         src="https://www.tripcaliber.com/Content/Images/qr-code.jpg"
//         alt="QR Code to download app"
//         width={120}
//         height={120}
//         style={{ borderRadius: 8, display: "block" }}
//       />
//     </div>
//     <h3 style={{ fontSize: 15, fontWeight: 700, color: "#0a2a6e", margin: "0 0 4px" }}>
//       QR Code
//     </h3>
//     <span style={{ fontSize: 12, color: "#718096" }}>Scan to download</span>
//   </div>
// </div>

//         </div>
//       </div>
//     </section>
//   );
// }

export default function App() {
  return (
    <>
      <WhyBookWithUs />
      {/* <MobileAppSection /> */}   
    </>   
  );
}